<template>
  <div>
    <b-alert :show="!flags.runnerEnabled && !loading" variant="warning">
      <div class="p-1">
        <small>Filo motoru sunucuda <strong>kapalı</strong> (FLEET_RUNNER_ENABLED). Filo oluşturup ayarlayabilirsin, ama başlatılan filolar sunucuda açılana kadar işlem yapmaz.</small>
      </div>
    </b-alert>

    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h4 class="mb-0">Filolar</h4>
          <div class="d-flex" style="gap: 0.5rem;">
            <b-button variant="outline-secondary" size="sm" :disabled="loading" @click="refresh">
              <b-spinner v-if="loading" small /> Yenile
            </b-button>
            <b-button variant="primary" size="sm" :to="{ name: 'FleetCreate' }">+ Akıllı Oluştur</b-button>
          </div>
        </div>
      </template>

      <div v-if="!loading && !list.length" class="text-center py-3">
        <h5>Henüz filon yok</h5>
        <p class="text-muted mb-2">
          Standart Filo, test edilmiş ayarla gelir: 6 motor, 12 slot, 3400 USDT, 4x, Sabit boyutlama, TESTNET (kağıt) modu.
          Taslak olarak oluşturulur, sen başlatana kadar işlem yapmaz.
        </p>
        <div class="d-flex justify-content-center" style="gap: 0.5rem;">
          <b-button variant="success" :disabled="busy" @click="onCreateDefault">Standart Filo'yu oluştur</b-button>
          <b-button variant="outline-primary" :to="{ name: 'FleetCreate' }">Kendi ayarınla oluştur</b-button>
        </div>
      </div>

      <b-table
        v-else
        :items="list"
        :fields="fields"
        responsive
        hover
        show-empty
        empty-text="Yükleniyor…"
        class="mb-0"
        @row-clicked="open"
      >
        <template #cell(name)="row">
          <router-link :to="{ name: 'FleetDetail', params: { id: row.item.id } }"><strong>{{ row.item.name }}</strong></router-link>
          <b-badge v-if="row.item.isDefault" variant="light-primary" class="ml-50">varsayılan</b-badge>
          <div><small class="text-muted">{{ row.item.slotCount }} slot · {{ row.item.leverage }}x · {{ sizingLabel(row.item.sizingMode) }}</small></div>
        </template>
        <template #cell(mode)="row">
          <b-badge :variant="row.item.mode === 'LIVE' ? 'danger' : 'light-info'">{{ row.item.mode === 'LIVE' ? 'LIVE' : 'TESTNET' }}</b-badge>
        </template>
        <template #cell(status)="row">
          <b-badge :variant="statusInfo(row.item.status).variant">{{ statusInfo(row.item.status).label }}</b-badge>
        </template>
        <template #cell(wallet)="row">
          {{ usd(row.item.wallet) }}
          <div><small class="text-muted">bütçe {{ usd(row.item.budget) }}</small></div>
        </template>
        <template #cell(netPnl)="row">
          <span :class="pnlClass(row.item.netPnl)">{{ usd(row.item.netPnl, true) }}</span>
          <div><small class="text-muted">{{ row.item.trades }} işlem</small></div>
        </template>
        <template #cell(openPositions)="row">
          {{ row.item.openPositions }} / {{ row.item.slotCount }}
          <div v-if="row.item.openPositions"><small :class="pnlClass(row.item.unrealizedPnl)">anlık {{ usd(row.item.unrealizedPnl, true) }}</small></div>
        </template>
        <template #cell(lastActivityAt)="row">
          <small>{{ time(row.item.lastActivityAt) }}</small>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BAlert, BButton, BBadge, BTable, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  STATUS_INFO, SIZING_INFO, formatUsd, formatTime, pnlClass,
} from './fleetFormat'

export default {
  name: 'FleetIndex',
  components: {
    BCard, BAlert, BButton, BBadge, BTable, BSpinner,
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Filo' },
        { key: 'mode', label: 'Mod' },
        { key: 'status', label: 'Durum' },
        { key: 'wallet', label: 'Cüzdan' },
        { key: 'netPnl', label: 'Net K/Z' },
        { key: 'openPositions', label: 'Dolu slot' },
        { key: 'lastActivityAt', label: 'Son hareket' },
      ],
      timer: null,
    }
  },
  computed: {
    list() { return this.$store.getters['fleet/list'] },
    flags() { return this.$store.getters['fleet/flags'] },
    loading() { return this.$store.getters['fleet/loading'] },
    busy() { return this.$store.getters['fleet/busy'] },
    saveStatus() { return this.$store.getters['fleet/dataSaveStatus'] },
  },
  watch: {
    saveStatus(val) {
      if (val.status === false) this.toast('danger', 'Hata', val.message)
    },
  },
  created() {
    this.refresh()
    this.timer = setInterval(() => this.$store.dispatch('fleet/getList'), 30000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    refresh() { this.$store.dispatch('fleet/getList') },
    open(item) { this.$router.push({ name: 'FleetDetail', params: { id: item.id } }) },
    onCreateDefault() {
      this.$store.dispatch('fleet/createDefault')
        .then(d => {
          this.toast('success', 'Tamam', 'Standart Filo oluşturuldu (Taslak).')
          if (d && d.fleet) this.open(d.fleet)
        })
        .catch(() => {})
    },
    statusInfo(s) { return STATUS_INFO[s] || { label: s, variant: 'light-secondary' } },
    sizingLabel(s) { return (SIZING_INFO[s] || { label: s }).label },
    usd: (v, sign) => formatUsd(v, sign),
    time: v => formatTime(v),
    pnlClass: v => pnlClass(v),
    toast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title, icon: variant === 'success' ? 'CheckIcon' : 'XIcon', text, variant,
        },
      })
    },
  },
}
</script>
